export default ({server}) => `{+sdk}
const terminal = StripeTerminal.create({
  onFetchConnectionToken: fetchConnectionToken,
  onUnexpectedReaderDisconnect: unexpectedDisconnect,
});

function unexpectedDisconnect() {
  // In this function, your app should notify the user that the reader disconnected.
  // You can also include a way to attempt to reconnect to a reader.
  console.log("Disconnected from reader")
}

{+fetch-connection-token}
async function fetchConnectionToken() {
  // Do not cache or hardcode the ConnectionToken. The SDK manages the ConnectionToken's lifecycle.
  const response = await fetch('${
    server === 'php' ? '/token.php' : '/connection_token'
  }', { method: "POST" });
  const data = await response.json();
  return data.secret;
}
{/fetch-connection-token}
{/sdk}

// Handler for a "Discover readers" button
function discoverReaderHandler() {
  {+discover-reader}
  const config = {simulated: true};
  const discoverResult = await terminal.discoverReaders(config);
  {/discover-reader}
  if (discoverResult.error) {
      console.log('Failed to discover: ', discoverResult.error);
  } else if (discoverResult.discoveredReaders.length === 0) {
      console.log('No available readers.');
  } else {
      discoveredReaders = discoverResult.discoveredReaders;
      log('terminal.discoverReaders', discoveredReaders);
  }
}

// Handler for a "Connect Reader" button
function connectReaderHandler(discoveredReaders) {
  // Just select the first reader here.
  {+connect-reader}
  const selectedReader = discoveredReaders[0];
  const connectResult = await terminal.connectReader(selectedReader);
  {/connect-reader}
  if (connectResult.error) {
      console.log('Failed to connect: ', connectResult.error);
  } else {
      console.log('Connected to reader: ', connectResult.reader.label);
      log('terminal.connectReader', connectResult)
  }
}

{+fetch-intent}
async function fetchPaymentIntentClientSecret(amount) {
  const bodyContent = JSON.stringify({ amount: amount });

  const response = await fetch('${
    server === 'php' ? '/create.php' : '/create_payment_intent'
  }', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: bodyContent
  }):
  const data = await response.json();
  return data.client_secret;
}
{/fetch-intent}

async function collectPayment(amount) {
  const client_secret = await fetchPaymentClientSecret(amount);
  {+test-cards}
  terminal.setSimulatorConfiguration({testCardNumber: '4242424242424242'});
  {/test-cards}
  {+collect-payment-method}
  const result = await terminal.collectPaymentMethod(client_secret)
  {/collect-payment-method}
  if (result.error) {
    // Placeholder for handling result.error
  } else {
      log('terminal.collectPaymentMethod', result.paymentIntent);
      {+process-payment}
      const result = await terminal.processPayment(result.paymentIntent) {
      {/process-payment}
      if (result.error) {
        // Placeholder for handling result.error
      } else if (result.paymentIntent) {
          paymentIntentId = result.paymentIntent.id;
          log('processPayment', result.paymentIntent);
      }
    };
  }
}

{+capture-intent}
async function capture(paymentIntentId) {
  const result = await fetch('${
    server === 'php' ? '/capture.php' : '/capture_payment_intent'
  }', {
      method: "POST",
      headers: {
         'Content-Type': 'application/json'
     	},
      body: JSON.stringify({"id": paymentIntentId})
  })

  const data = result.json();
  log('server.capture', data);
}
{/capture-intent}

var discoveredReaders;
var paymentIntentId;

const discoverButton = document.getElementById('discover-button');
discoverButton.addEventListener('click', async (event) => {
  discoverReaderHandler();
});

const connectButton = document.getElementById('connect-button');
connectButton.addEventListener('click', async (event) => {
  connectReaderHandler(discoveredReaders);
});

const collectButton = document.getElementById('collect-button');
collectButton.addEventListener('click', async (event) => {
  amount = document.getElementById("amount-input").value
  collectPayment(amount);
});

const captureButton = document.getElementById('capture-button');
captureButton.addEventListener('click', async (event) => {
  capture(paymentIntentId);
});

function log(method, message){
  var logs = document.getElementById("logs");
  var title = document.createElement("div");
  var log = document.createElement("div");
  var lineCol = document.createElement("div");
  var logCol = document.createElement("div");
  title.classList.add('row');
  title.classList.add('log-title');
  title.textContent = method;
  log.classList.add('row');
  log.classList.add('log');
  var hr = document.createElement("hr");
  var pre = document.createElement("pre");
  var code = document.createElement("code");
  code.textContent = formatJson(JSON.stringify(message, undefined, 2));
  pre.append(code);
  log.append(pre);
  logs.prepend(hr);
  logs.prepend(log);
  logs.prepend(title);
}

function formatJson(message){
  var lines = message.split('\\n');
  var space = " ".repeat(2);
  var json = "";
  for(var i = 1; i <= lines.length; i += 1){
    line = i + space + lines[i-1];
    json = json + line + '\\n';
  }
  return json
}
`;
